import { makeStyles } from '@material-ui/core';
import cloudhouseMark from './cloudhouse-logo-square.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
    display: 'block',
  },
});

// Official Cloudhouse mark (square gear, green on transparent), bundled via
// import. Shown when the sidebar is collapsed.
export const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src={cloudhouseMark} alt="Cloudhouse" />;
};
